<yc-modal
  [modalHeader]="'common:hdrSelectAccountToAdminister' | ycI18n: 'Select Account to Administer'"
  [primaryButtonText]="'common:textContinue' | ycI18n: 'Continue'"
  (onPrimaryClick)="closeModal.emit(selectedClient.clientId)">

  <div role="region">
    <div role="grid">
      <div role="rowgroup">
        <div *ngFor="let row of associatedClients;"
          class="client-block"
          role="row"
          [tabIndex]="0"
          [attr.aria-selected]="selectedClient?.clientId === row.clientId"
          [attr.aria-label]="row.clientName"
          [class.client-selected]="selectedClient?.clientId === row.clientId"
          (click)="selectedClient = row;"
          (keyup.enter)="selectedClient = row;">
          <div class="d-flex align-items-center">
            <img
              [src]="row.logo || './assets/img/placeholders/grants-icon-placeholde-dark.svg'"
              [alt]="'GLOBAL:textClientLogo' | ycI18n: 'Client logo'">
            <div class="font-550 font-875-rem">
              {{ row.clientName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</yc-modal>